import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Collapse, DatePicker, Popover, Row, Tabs } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
  updateGlobalSearch,
} from "../../actions";
import MainLayout from "../../components/layouts/main";
import Constants from "../../data/constants";
import moment from "moment";
import OnlineStatusAnalytics from "./OnlineStatusAnalytics";
import { BarChart2 } from "lucide-react";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

function AnalyticsPage(props) {
  const { lang } = useProLanguage();
  const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).analytics;

  const [page, setPage] = useState(1);
  const [perPage, setPerPageage] = useState(20);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const { selectedBrandData } = props;

    if (!selectedBrandData) return;

    // getScreensStatusList();
    // reloadLicenses();
    // Fetch licenses data from the server or perform any other side effects here
  }, []);

  return (
    <>
      <MainLayout
        id={Constants.ANALYTICS_PAGE}
        quietTitleBar={true}
        style={{ padding: 20 }}
        showTopBarBrandLogo={true}
        showSearchBar={true}
        renderBreadCrumb={() => [
          <span style={{ fontSize: 14, fontWeight: 500, color: "#94a3b8", padding: "4px 8px", lineHeight: "22px" }}>
            {t.pageTitle || "Analytics"}
          </span>,
        ]}
      >
        {/* Page header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#fff",
            borderRadius: 16,
            padding: "20px 24px",
            border: "1px solid #e8ecf3",
            marginBottom: 20,
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <div
              style={{
                width: 52,
                height: 52,
                borderRadius: 14,
                flexShrink: 0,
                background: "linear-gradient(135deg,#0ea5e9,#0284c7)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <BarChart2 size={26} color="#fff" />
            </div>
            <div>
              <div style={{ fontSize: 22, fontWeight: 800, color: "#0f172a", lineHeight: 1.2 }}>
                {t.pageTitle}
              </div>
              <div style={{ fontSize: 13, color: "#94a3b8", marginTop: 3 }}>
                {t.pageSubtitle}
              </div>
            </div>
          </div>
        </div>
        <Tabs
          defaultActiveKey="1"
          style={{
            background: "#fff",
            borderRadius: 16,
            padding: "0 16px",
            border: "1px solid #f1f5f9",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
          }}
        >
          <Tabs.TabPane tab={t.tabScreenHealth} key="1">
            <OnlineStatusAnalytics parentProps={props}></OnlineStatusAnalytics>
          </Tabs.TabPane>
        </Tabs>
      </MainLayout>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    globalSearch: state.globalSearch,
    selectedBrandData: state.selectedBrandData,
  };
};

export default connect(mapStateToProps, {
  updateGlobalSearch,
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
})(AnalyticsPage);
